angular.module('inspinia').controller('UploadCompletedModalCtrl', function ($scope, $modalInstance, files) {
  const init = function () {
    $scope.files = files ? files : [];
    $scope.numberOfErrors = $scope.files.length;
    $scope.showErrorDetails = false;
  };

  $scope.toggleDetails = function () {
    $scope.showErrorDetails = !$scope.showErrorDetails;
  };

  init();
});
